import { useState, useEffect } from 'react'
import { useLDClient } from 'launchdarkly-react-client-sdk'

const buildLaunchDarklyContext = me => ({
  kind: 'multi',
  user: {
    kind: 'user',
    key: me.id,
  },
  company: {
    kind: 'company',
    key: me.company.id,
    name: me.company.name,
  },
})

const isCurrentContext = (currentContext, builtContext) => {
  if (!currentContext) return false

  if (currentContext.kind === 'multi') {
    return (
      currentContext.user?.key === builtContext.user.key &&
      currentContext.company?.key === builtContext.company.key
    )
  }
}

function useLaunchDarkly(me) {
  const ldDisabled =
    process.env.REACT_APP_LAUNCH_DARKLY_ENABLED === 'false' ? true : false
  const [ldInitialised, setLdInitialised] = useState(ldDisabled)
  const ldClient = useLDClient()

  useEffect(() => {
    if (!ldClient || !me) {
      return
    }

    const { launchDarklyHash } = me
    const currentContext = ldClient.getContext?.()
    const builtContext = buildLaunchDarklyContext(me)

    // Prevent unnecessary identify calls if context is already set to the correct user and company
    const initialised = isCurrentContext(currentContext, builtContext)
    if (!initialised) {
      // enable app to work if LaunchDarkly is unavailable
      /* istanbul ignore next */
      ldClient.on('error', () => {
        setLdInitialised(true)
      })

      ldClient
        .identify(
          builtContext,
          launchDarklyHash
        )
        .finally(() => {
          setLdInitialised(true)
        })
    } else if (initialised && !ldInitialised) {
      setLdInitialised(true)
    }
  }, [ldClient, me, ldInitialised])

  return { ldInitialised }
}

export { buildLaunchDarklyContext, useLaunchDarkly }
